// extracted by mini-css-extract-plugin
export default {"searchBar":"SearchBar_searchBar__sJnG7","clear":"SearchBar_clear__W8EPW"};